import React from 'react'
import styled from 'styled-components'

import { device } from '../../lib/deviceSizes'

const StyledButton = styled.button`
  width: 120px;
  margin: 5px 5px 0 5px ;
  padding: 1px 0 0 0;

  border-radius: 21.5px;
  color: #4a4a4a;
  border: 1px solid #ffffff;
  background-color: #ffffff;

  font-family: ProximaNova-Regular;
  font-size: 16px;
  outline: 0;

  &:hover {
    border: 1px solid rgba(192, 192, 192, 0.5);
  }
  &:active {
    border-color: rgba(192, 192, 192, 1);
  }

  @media ${device.xSmall} {
    width: 25vw;
    font-size: calc(10px + 1vw);
  }
`

export const Button = (props) => (
  <StyledButton
    className={props.className}
    onClick={props.onClick}
  >
    {props.children}
  </StyledButton>
)



// WEBPACK FOOTER //
// ./src/components/shared/button.js